import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService} from '../../services/user.service';
import {InfluencerDetail, InfluencerInfo} from '../../../models/influencer';
import {CommonConstant, InfluencerTab, InfluencerTabName} from '../../app.constants';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {Subscription} from 'rxjs/Subscription';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';
import {PdfViewerService} from '../../main/pdf-viewer/pdf-viewer.service';
import {DemographicComponent} from '../../main/influencer/demographic/demographic.component';

@Component({
  selector: 'influencer-details',
  templateUrl: './influencer-details.component.html',
  styleUrls: ['./influencer-details.component.scss']
})
export class InfluencerDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('AlertPdfDownloadPending')
  public alertPdfDownloadPending: AchooPopupComponent;

  private currentInfluencer: InfluencerInfo;
  private influencerDetail: InfluencerDetail;
  private activeTabIndex: number;
  private exportPdfSubcription: Subscription;
  private channelFollowerParam: string;
  private insightChannelParam: number;
  private demographicChannelParam: number;

  constructor(private userService: UserService,
              private placeholderService: PlaceholderVisibilityService,
              private influencerService: InfluencerService,
              private location: Location,
              private modalService: ModalService,
              private pdfViewerService: PdfViewerService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.currentInfluencer = this.userService.getInfluencerInfo();
    this.route.data.subscribe(res => {
      this.activeTabIndex = res.order;
    });
    this.initializeComponent();
  }

  ngOnDestroy() {
    if (this.exportPdfSubcription) {
      this.exportPdfSubcription.unsubscribe();
    }
    // clear active channel
    this.influencerService.updateActiveChannel(null);
  }

  onChangeActiveChannel(evt) {
    if (evt) {
      this.insightChannelParam = evt.channel;
      this.updateUrl(evt.activeTab, evt.channelFollower);
    }
  }

  changeDemographicSource(channelId) {
    this.demographicChannelParam = channelId;
    this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
  }

  private initializeComponent() {
    this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
    this.influencerService.getInfluencer(this.currentInfluencer.id).subscribe((data) => {
      this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
      this.influencerDetail = data;
      this.route.queryParams.subscribe(params => {
        const selectedChannel = this.influencerDetail.channels.find(c => c.id === Number(params.insightChannel));
        if (selectedChannel) {
          this.influencerService.updateActiveChannel(selectedChannel);
        }
      });
    });
  }

  get currentInfluencerId() {
    return this.currentInfluencer ? this.currentInfluencer.id : null;
  }

  showInsight() {
    this.activeTabIndex = InfluencerTab.INSIGHT;
    this.updateUrl(InfluencerTabName.INSIGHT);
  }

  showDemographics() {
    this.activeTabIndex = InfluencerTab.DEMOGRAPHIC;
    this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
  }

  showOverview() {
    this.activeTabIndex = InfluencerTab.OVERVIEW;
    this.updateUrl(InfluencerTabName.OVERVIEW);
  }

  public downloadPDF() {
    // cancel previous request
    if (this.exportPdfSubcription) {
      this.exportPdfSubcription.unsubscribe();
    }
    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
    this.exportPdfSubcription = this.pdfViewerService.generateInfluencerDetailPdf(
      this.currentInfluencer.id, this.demographicChannelParam, this.userService.getCompanyId(),
      this.channelFollowerParam, this.insightChannelParam).subscribe();
  }
  public closePopup() {
    this.modalService.close();
  }

  private updateUrl(activeTab, channelFollowerIds?) {
    let params = {};
    if (this.insightChannelParam) {
      params = Object.assign({}, params, {
        insightChannel: this.insightChannelParam
      });
    }
    if (this.demographicChannelParam) {
      params = Object.assign({}, params, {
        demographicChannel: this.demographicChannelParam
      });
    }
    if (channelFollowerIds) {
      params = Object.assign({}, params, { channelFollower: channelFollowerIds });
    }
    this.channelFollowerParam = channelFollowerIds;
    const url = this.router.createUrlTree(['dashboard/details', activeTab], {
      queryParams: params
    }).toString();

    this.location.go(url);
  }

  get isActiveInsightTab() {
    return this.influencerDetail && this.activeTabIndex === InfluencerTab.INSIGHT;
  }
  get isActiveDemographicTab() {
    return this.influencerDetail && this.activeTabIndex === InfluencerTab.DEMOGRAPHIC;
  }
  get isActiveOverviewTab() {
    return this.influencerDetail && this.activeTabIndex === InfluencerTab.OVERVIEW;
  }

  get isActiveActvityTab() {
    return this.influencerDetail && this.activeTabIndex === InfluencerTab.OVERVIEW;
  }

  get influencerDetailsData() {
    return this.influencerDetail;
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-details.component.ts